
import { defineComponent, ref, reactive } from 'vue';
export default defineComponent({
  name: 'BulletinBar',
  setup() {},
});
